
/*
isNil(null); //=> true
isNil(undefined); //=> true
isNil(0); //=> false
isNil([]); //=> false
*/
export default function (value) {
  return value == null;
}
